// extracted by mini-css-extract-plugin
export var cardTitle = "_cd-1";
export var commentBubble = "_cd-e";
export var commentForm = "_cd-a";
export var commentInput = "_cd-b";
export var commentLabel = "_cd-d";
export var commentPrompt = "_cd-9";
export var csatCard = "_cd-0";
export var feedbackSection = "_cd-7";
export var starDisabled = "_cd-6";
export var starEmpty = "_cd-5";
export var starFilled = "_cd-4";
export var starWrapper = "_cd-3";
export var starsContainer = "_cd-2";
export var submittedComment = "_cd-c";
export var thankYouText = "_cd-8";